import { useEffect } from "react";

const REFERRAL_COOKIE_NAME = "referral_code";
const REFERRAL_COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

/**
 * Captures a `?ref=...` query parameter from the URL
 * and stores it in a cookie so the backend can read it
 * during signup.
 */
export function useReferral() {
	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const ref = params.get("ref");

		if (ref && ref.length >= 6 && ref.length <= 16) {
			// Only set cookie if we don't already have one
			const existing = document.cookie
				.split("; ")
				.find((row) => row.startsWith(`${REFERRAL_COOKIE_NAME}=`));

			if (!existing) {
				// biome-ignore lint/suspicious/noDocumentCookie: Cookie Store API has limited browser support; document.cookie is required here
				document.cookie = `${REFERRAL_COOKIE_NAME}=${encodeURIComponent(ref)}; path=/; max-age=${REFERRAL_COOKIE_MAX_AGE}; SameSite=Lax`;
			}

			// Clean the URL without reloading the page
			if (params.has("ref")) {
				params.delete("ref");
				const newUrl =
					params.toString().length > 0
						? `${window.location.pathname}?${params.toString()}`
						: window.location.pathname;
				window.history.replaceState({}, "", newUrl);
			}
		}
	}, []);
}
